import { render, staticRenderFns } from "./TerminalsWaveletForm.vue?vue&type=template&id=9995cbbe&"
import script from "./TerminalsWaveletForm.vue?vue&type=script&lang=js&"
export * from "./TerminalsWaveletForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports